module.exports = __webpack_public_path__ + "img/Marquee-04.a2fbab48.jpg";